/**
 * CheckmarkCircleIcon/index.js
 * desc: inline confirm icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CheckmarkCircleIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="inline-confirm icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.checkmarkCircle.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 5.376 5.376 0 12 0s12 5.376 12 12-5.376 12-12 12S0 18.624 0 12zm5 0l5 5 9-9-1.41-1.42L10 14.17l-3.59-3.58L5 12z" /></svg>
    </IconButton>
);


export default CheckmarkCircleIcon;
